import { COMMON_REMOVE_PRESUPUESTO_ULTIMO_EDITADO } from './constants';

const PRESUPUESTADOR = 'Presupuestador';
const SLUG_ULTIMO_EDITADO = 'presupuestador/ultimo-editado';

export function removeMenuPresupuestoUltimoEditado() {
  return (dispatch, getState) => {
    const { common: { user: { system } }} = getState();

    const newSystem = system.map(menuItem => {
      if(menuItem.name === PRESUPUESTADOR) {
        menuItem.content = menuItem.content.filter(item => item.slug !== SLUG_ULTIMO_EDITADO)
      }
      return menuItem
    })
  
    dispatch({
      type: COMMON_REMOVE_PRESUPUESTO_ULTIMO_EDITADO,
      data: newSystem,
    })

  }
}

export function reducer(state, action) {
  if (action.type === COMMON_REMOVE_PRESUPUESTO_ULTIMO_EDITADO) {
      return {
        ...state,
        user: {
          ...state.user,
          system: action.data
        }
      }
  }
  else{
      return state
  }    
}
